export default __webpack_public_path__ + "static/Dataone_logo-a97f5421108b36568db96335838bb16f.png";